/*** IMPORTS FROM imports-loader ***/
var define = false;

export { default } from './components/Icon';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/icons-react/es/index.js
// module id = 537
// module chunks = 0